import './setupPdfWorker';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';


const root = ReactDOM.createRoot(document.getElementById('root'));
// StrictMode is off: react-pdf / pdfjs-dist tear down the worker in effect cleanups, and React 18
// StrictMode double-invokes those effects in dev, which leaves WorkerTransport.messageHandler null
// and causes "Cannot read properties of null (reading 'sendWithPromise')".
root.render(<App />);
